import { useEffect, useState } from 'react';

import axios from 'axios';
import uniqBy from 'lodash/uniqBy';
import { toast } from 'react-toastify';

import { Card, CircularProgress, Grid } from '@mui/material';

import MDAlert from 'components/MDAlert';
import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';
import MDTypography from 'components/MDTypography';
import UsersList from './components/UsersList';

import usePaginationHook from 'hooks/usePaginationHook';

import { formatDate } from 'helpers/formatData';
import { getNotifications } from 'services/dashboard.service';

function Notifications() {
  const [notificationsList, setNotificationsList] = useState([]);
  const [header, setHeader] = useState('Notifications');
  const [totalCount, setTotalCount] = useState(0);

  const [isDuplicateListModal, setIsDuplicateListModal] = useState(false);
  const [extraData, setExtraData] = useState({
    modalTitle: '',
    type: '',
    data: [],
  })

  const { currentPage, setCurrentPage, perPage, setPerPage } =
    usePaginationHook();

  const [loader, setLoader] = useState(true);
  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();
  // Handler Function
  const setSeverity = (val) => {
    switch (val) {
      case 'success':
        return 'success';
      case 'warning':
        return 'warning';
      case 'failed':
        return 'error';
      default:
        return 'info';
    }
  };
  const handleShowAllNotification = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };
  //API Integration
  const fetchNotification = async () => {
    setLoader(true);
    try {
      const res = await getNotifications(perPage, currentPage, source.token);
      if (!res.isError) {
        // setNotificationsInfo({notifications: });
        setNotificationsList(
          uniqBy(
            [...notificationsList, ...(res?.data?.notifications ?? null)],
            'id'
          )
        );
        setTotalCount(res?.data?.count);
        !Boolean(res?.data?.count) && setHeader('No Notifications');
        setLoader(false);
      } else {
        toast.error(res?.message);
        setHeader('No Notifications');
        setLoader(false);
      }
    } catch (error) {
      const { response } = error;
      response?.data?.message && toast.error(response?.data?.message);
    }
  };

  useEffect(() => {
    setCurrentPage(1);
  }, []);

  useEffect(() => {
    fetchNotification();
    return () => source.cancel('Component got unmounted');
  }, [currentPage]);

  const onShowMoreBtnClick = (notification) => () => {
    setExtraData({
      modalTitle: notification?.notificationTitle ?? '',
      type: notification?.extraData?.type ?? '',
      data: notification.extraData?.data ?? [],
    });
    setIsDuplicateListModal(true);
  }

  const onUsersListModalClose = () => {
    setIsDuplicateListModal(false);
    setExtraData({
      modalTitle: '',
      type: '',
      data: [],
    });
  }

  return (
    <>
      <MDBox mt={6} mb={3}>
        <Grid container spacing={3} justifyContent='center'>
          <Grid item xs={12} lg={8}>
            <Card>
              <MDBox p={2}>
                <MDTypography variant='h5' textAlign='center'>
                  {header}
                </MDTypography>
              </MDBox>
              {/* === Notifications Start Here === */}
              {loader ? (
                <div style={{ textAlign: 'center' }}>
                  <CircularProgress color="inherit" size={30} />
                </div>
              ) : (
                <MDBox pt={2} px={2}>
                  {notificationsList?.map((val) => {
                    return (
                      <MDAlert color={setSeverity(val.severity)} key={val.id}>
                        <MDBox sx={{ width: '100%' }}>
                          <MDTypography
                            variant='body2'
                            color='white'
                            fontWeight='bold'
                          >
                            {val?.notificationTitle ?? 'No title'}
                          </MDTypography>
                          <MDTypography
                            variant='body2'
                            color='white'
                            fontWeight='regular'
                          >
                            {val?.description ?? 'NA'}
                          </MDTypography>
                          {val?.extraData?.data?.length && <MDBox mt={1} mb={2} sx={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                          }}>
                            <MDButton size="small" onClick={onShowMoreBtnClick(val)}>
                              Show Users List
                            </MDButton>
                          </MDBox>}
                          <MDTypography
                            variant='body2'
                            color='white'
                            fontSize='small'
                            textAlign='right'
                          >
                            {formatDate(val?.createdAt, 'MMM DD, YYYY h:mm A')}
                          </MDTypography>
                        </MDBox>
                      </MDAlert>
                    );
                  })}
                  {totalCount > notificationsList?.length && (
                    <MDBox my={3} textAlign='center'>
                      <MDButton
                        variant='gradient'
                        color='info'
                        isLoading={loader}
                        disabled={loader}
                        onClick={handleShowAllNotification}
                      >
                        Show More Notifications
                      </MDButton>
                    </MDBox>
                  )}
                  {notificationsList.length === 0 && loader && (
                    <MDBox my={3} textAlign='center'>
                      <CircularProgress color='inherit' size={30} />
                    </MDBox>
                  )}
                </MDBox>
              )}
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      {isDuplicateListModal && (
        <UsersList
          isOpen={isDuplicateListModal}
          onClose={onUsersListModalClose}
          modalTitle={extraData.modalTitle}
          usersData={extraData.data}
        />
      )}
    </>
  );
}

export default Notifications;
